import React from 'react'
// import styles from './PrintOfficialPDFDialog.scss'
import {ConfirmationDialog} from 'common/styleguide/ConfirmationDialog'

export const PRINT_OFFICIAL_PDF_DIALOG = 'PRINT_OFFICIAL_PDF_DIALOG'

export class PrintOfficialPDFDialog extends React.PureComponent {
  navigateToPrintPage = () => {
    const {doPrint} = this.props
    doPrint()
  }

  downloadOfficialPDF = () => {
    const {route} = this.props
    const mapPdf = route.get('mapPdf')
    window.open(mapPdf.url)
  }

  render () {
    const {route, onRequestClose} = this.props
    const club = route.get('club')

    return (
      <ConfirmationDialog
        onRequestClose={onRequestClose}
        cancelText='Customize PDF'
        onCancel={this.navigateToPrintPage}
        confirmText='Print Official'
        onConfirm={this.downloadOfficialPDF}>
        This route has an Official PDF{club && club.name && ` provided by ${club.name}`}. You can print the Official PDF or change the settings to customize your map and cue sheet.
      </ConfirmationDialog>
    )
  }
}
